import script from "./AdminUser.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUser.vue?vue&type=script&setup=true&lang=js"

import "./AdminUser.vue?vue&type=style&index=0&id=2309a900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2309a900"]])

export default __exports__